var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-currency",
      class: {
        "ns-currency__loading": _vm.loading,
        "ns-currency__strike-through": _vm.strikeThrough
      },
      attrs: { "data-qa-price": _vm.amount, "data-qa-priceType": _vm.priceType }
    },
    [_vm._v("\n  " + _vm._s(_vm.formattedCurrency) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }